/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, ValidateProduct } from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { hasEnoughInventory } from "@monsma/App/Handlers/Data/Products/ProductsSelectors";

// xng-change: custom hasEnoughInventory call
const XngValidateProduct: typeof ValidateProduct = ({ parameter, product, productInfo, getState, dispatch }: any) => {
    if (!parameter.validateProduct || !product || !productInfo) {
        return;
    }

    if (
        product.canConfigure ||
        (product.configurationType !== ConfigurationType.Fixed && product.configurationType !== ConfigurationType.None)
    ) {
        dispatch({
            type: "Components/ProductSelector/SetErrorType",
            errorType: "productIsConfigurable",
        });
    }

    if (product.isVariantParent) {
        dispatch({
            type: "Components/ProductSelector/OpenVariantModal",
            productId: product.id,
        });

        return false;
    }

    if (!parameter.skipInventoryValidation && !hasEnoughInventory(getState(), { product, productInfo })) {
        dispatch({
            type: "Components/ProductSelector/SetErrorType",
            errorType: "productIsUnavailable",
        });
    }
};

replaceInChain(chain, ValidateProduct, XngValidateProduct);
